import { render, staticRenderFns } from "./configContactInfo.vue?vue&type=template&id=c1fff3bc&scoped=true"
import script from "./configContactInfo.vue?vue&type=script&lang=js"
export * from "./configContactInfo.vue?vue&type=script&lang=js"
import style0 from "./configContactInfo.vue?vue&type=style&index=0&id=c1fff3bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fff3bc",
  null
  
)

export default component.exports